<template>
    <div class="more-appointment">
        <table-info
            :columns="moreAppointmentColumns"
            :table-data="moreAppointmentData"
            :limitMoveNum="11"
        />
    </div>
</template>
<script>
import TableInfo from '@/components/TableInfo'
import * as fcScreenAPI from '@/api/fc-screen'
import Socket, { uri, MACHINEAPPOINT } from '@/socket/index'
import eventHub from '@/utils/eventHub'

export default {
    components: { TableInfo },
    data() {
        return {
            moreAppointmentColumns: [
                { title: '作业地点', field: 'locInfoAddress', width: '40%' },
                {
                    title: '所需农机',
                    field: 'machineTypeName'
                },
                { title: '作业面积', field: 'landArea', type: 'emphasize' },
                { title: '联系电话', field: 'contactPhone' },
                { title: '单价', field: 'unitPriceName', type: 'emphasize' },
                { title: '预约时间', field: 'jobTimeStart' },
                {
                    title: '状态',
                    field: 'businessStatusDesc',
                    type: 'statusColor',
                    statusField: 'businessStatus'
                }
            ],
            moreAppointmentData: []
        }
    },
    methods: {
        async getMoreAppointmentColumns() {
            const currScreenType = JSON.parse(
                sessionStorage.getItem('currScreenType')
            )
            const response = await fcScreenAPI.getAmList(currScreenType.locId)
            if (response && response.data.length) {
                this.moreAppointmentData = response.data
                this.moreAppointmentData.forEach((item) => {
                    const town = item.locInfo.split('/')
                    item.locInfoAddress = town[town.length - 1] + item.address
                    item.landArea = `${item.landArea}亩`
                    item.unitPriceName = item.price
                        ? item.price + item.priceUnitName
                        : item.priceUnitName
                })
            }
        }
    },
    mounted() {
        this.getMoreAppointmentColumns()

        // 初始化 socket
        Socket.inits(uri)

        // 接收 socket 信息
        eventHub.$on(MACHINEAPPOINT, (data) => {
            const town = data.locInfo.split('/')
            data.locInfoAddress = town[town.length - 1] + data.address
            data.landArea = `${data.landArea}亩`
            data.unitPriceName = data.price
                ? data.price + data.priceUnitName
                : data.priceUnitName
            const index = this.moreAppointmentData.findIndex(
                (item) => item.id === data.id
            )
            if (index === -1) {
                this.moreAppointmentData.unshift(data)
            } else {
                this.moreAppointmentData.splice(index, 1)
                this.moreAppointmentData.unshift(data)
            }
        })
    },
    destroyed() {
        // 销毁 socket
        Socket.destroy()

        eventHub.$off(MACHINEAPPOINT)
    }
}
</script>
<style lang="scss" scoped>
.more-appointment {
    width: calc(100% - 32px);
    height: calc(100% - 108px);
    background-image: url('../../assets/images/appointment-box.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 21px 15px 14px 15px;
    .table-info {
        height: 100%;
        ::v-deep {
            .header {
                height: 55px;
                line-height: 55px;
            }
            .list {
                height: calc(100% - 80px);
                margin: 16px 0;
                .item {
                    height: 55px;
                    margin-bottom: 16px;
                    padding: 0;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .text {
                        font-size: 16px;
                    }
                }
            }
        }
    }
}
</style>
